
import { defineComponent, PropType } from '@vue/runtime-core'
import LatterList from '@/components/block/LatterList.vue'
import { Specialist } from '@/types/HospitalDetail'

export default defineComponent({
  components: {
    LatterList
  },

  props: {
    list: {
      type: Object as PropType<Specialist[]>,
      default: () => ({})
    },
    showLatterDetail: {
      type: Function as PropType<(s_training_id: number) => void>,
      required: true
    }
  }
})
